import PropTypes from 'prop-types';

const questionPropType = PropTypes.shape({
    question_id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string,
    version_id: PropTypes.number,
    group: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string.isRequired,
        group_order: PropTypes.number.isRequired,
    }),
    attributes: PropTypes.shape({
        position: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        therigy_required: PropTypes.bool,
    }),
    can_delete: PropTypes.bool,
});

export default questionPropType;
